(function () {
  function initAppSwitcher(root) {
    var appShells = root.querySelectorAll('[data-pum-app]');

    appShells.forEach(function (appShell) {
      if (appShell.dataset.pumAppInitialized === 'true') {
        return;
      }

      var grid = appShell.querySelector('[data-pum-app-grid]');
      if (!grid) {
        return;
      }

      var defaultApp = appShell.dataset.pumDefaultApp || '1';
      var cards = grid.querySelectorAll('[data-pum-app-card]');

      function setActive(cardIndex) {
        appShell.dataset.pumActiveApp = cardIndex || defaultApp;
      }

      cards.forEach(function (card) {
        var cardIndex = card.dataset.pumAppCard || defaultApp;

        card.addEventListener('pointerenter', function () {
          setActive(cardIndex);
        });

        card.addEventListener('focusin', function () {
          setActive(cardIndex);
        });

        card.addEventListener('click', function () {
          setActive(cardIndex);
        });
      });

      grid.addEventListener('pointerleave', function () {
        setActive(defaultApp);
      });

      appShell.dataset.pumAppInitialized = 'true';
    });
  }

  function init(root) {
    initAppSwitcher(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
